import { createUrlStore } from "../../utils/createUrlStore.ts";
import { BOARD_STATE_BY_PRESET } from "./presets.ts";
import type { BoardState, StatePreset } from "./types.ts";
import { retrieveAndClearInputUrlParams } from "./utils/getAndClearInputUrlParams.ts";
import { setBoardState } from "./utils/setBoardState.ts";

type State = {
  boardStatePreset: StatePreset | undefined;
};

type Actions = {
  setBoardStatePreset: ({
    boardUuid,
    boardStatePreset,
    baseBoardState,
  }: {
    boardUuid: string;
    boardStatePreset?: StatePreset;
    baseBoardState?: Partial<BoardState>;
  }) => void;
};

export const boardStatePresetStore = createUrlStore<State, Actions>(
  { boardStatePreset: undefined },
  {
    boardStatePreset: {
      paramName: "preset",
      serialize: (value) => value ?? "",
      deserialize: (value) => value as StatePreset,
    },
  },
  ({ set }) => ({
    setBoardStatePreset: ({
      boardUuid,
      boardStatePreset,
      baseBoardState,
    }: {
      boardUuid: string;
      boardStatePreset?: StatePreset;
      baseBoardState?: Partial<BoardState>;
    }) => {
      set({ boardStatePreset });
      const inputUrlParams = retrieveAndClearInputUrlParams();
      // XXX: We currently give precedence to the preset state over the input url params. However this behavior must be discussed so we can decide what's the best behavior.
      const boardState = boardStatePreset
        ? {
            ...baseBoardState,
            ...inputUrlParams,
            ...BOARD_STATE_BY_PRESET[boardStatePreset],
          }
        : {
            ...baseBoardState,
            ...inputUrlParams,
          };

      setBoardState(boardUuid, boardState);
    },
  }),
);
